import { render } from "./InvoiceCreate.vue?vue&type=template&id=bed15148"
import script from "./InvoiceCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceCreate.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Billing/InvoiceCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bed15148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bed15148', __exports__)) {
    api.reload('bed15148', __exports__)
  }
  
  module.hot.accept("./InvoiceCreate.vue?vue&type=template&id=bed15148", () => {
    api.rerender('bed15148', render)
  })

}


export default __exports__